import { render, staticRenderFns } from "./fechas-movilidad.vue?vue&type=template&id=397a50b8&scoped=true&"
import script from "./fechas-movilidad.component.ts?vue&type=script&lang=ts&"
export * from "./fechas-movilidad.component.ts?vue&type=script&lang=ts&"
import style0 from "./fechas-movilidad.vue?vue&type=style&index=0&id=397a50b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a50b8",
  null
  
)

export default component.exports